import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = { class: "primary-gradient-bg text-center my-5 py-5" }
const _hoisted_3 = { class: "container container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8 offset-md-2" }
const _hoisted_6 = { class: "text-white mb-4" }
const _hoisted_7 = { class: "text-white" }
const _hoisted_8 = { class: "pb-5" }
const _hoisted_9 = { class: "container container-fluid" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between mb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "main-section-title fw-bold" }, "General")
], -1)
const _hoisted_11 = { class: "row d-flex" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "col-md-4 mb-4" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  src: "/images/general-1.png",
  alt: "About Us",
  class: "w-100"
}
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  src: "/images/general-1.png",
  alt: "About Us",
  class: "w-100"
}
const _hoisted_19 = { class: "pb-5" }
const _hoisted_20 = { class: "container container-fluid" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between mb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "main-section-title fw-bold" }, "Look Around")
], -1)
const _hoisted_22 = { class: "row d-flex" }
const _hoisted_23 = { class: "col-md-4 mb-4" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  src: "/images/general-1.png",
  alt: "About Us",
  class: "w-100"
}
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "pb-5" }
const _hoisted_28 = { class: "container container-fluid" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between mb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "main-section-title fw-bold" }, "Our Venue Providers")
], -1)
const _hoisted_30 = { class: "row d-flex" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "col-md-4 mb-4" }
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 1,
  src: "/images/venue_providers.png",
  alt: "About Us",
  class: "w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_PageLoader = _resolveComponent("PageLoader")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    (_ctx.page_items != null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.page_items.header_title), 1),
                  _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.page_items.header_text), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "col-md-8 mb-4",
                  innerHTML: _ctx.page_items.general_text
                }, null, 8, _hoisted_12),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.page_items && _ctx.page_items.general_photo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.page_items.general_photo,
                        alt: "About Pcado",
                        class: "w-100"
                      }, null, 8, _hoisted_14))
                    : (_openBlock(), _createElementBlock("img", _hoisted_15))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.page_items && _ctx.page_items.divider_photo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.page_items.divider_photo,
                        alt: "About Pcado",
                        class: "w-100"
                      }, null, 8, _hoisted_17))
                    : (_openBlock(), _createElementBlock("img", _hoisted_18))
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_ctx.page_items && _ctx.page_items.look_around_photo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.page_items.look_around_photo,
                        alt: "About Pcado",
                        class: "w-100"
                      }, null, 8, _hoisted_24))
                    : (_openBlock(), _createElementBlock("img", _hoisted_25))
                ]),
                _createElementVNode("div", {
                  class: "col-md-8 mb-4",
                  innerHTML: _ctx.page_items.look_around_text
                }, null, 8, _hoisted_26)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", {
                  class: "col-md-8 mb-4",
                  innerHTML: _ctx.page_items.our_venue_providers_text
                }, null, 8, _hoisted_31),
                _createElementVNode("div", _hoisted_32, [
                  (_ctx.page_items && _ctx.page_items.our_venue_providers_photo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.page_items.our_venue_providers_photo,
                        alt: "About Picado",
                        class: "w-100"
                      }, null, 8, _hoisted_33))
                    : (_openBlock(), _createElementBlock("img", _hoisted_34))
                ])
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createBlock(_component_PageLoader, { key: 1 })),
    _createVNode(_component_Footer)
  ]))
}